import { render, staticRenderFns } from "./ContactPermissions.vue?vue&type=template&id=f8ececba"
import script from "./ContactPermissions.vue?vue&type=script&lang=js"
export * from "./ContactPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports